import { render, staticRenderFns } from "./EmbeddedViewer.vue?vue&type=template&id=3fa3558a&scoped=true&"
import script from "./EmbeddedViewer.vue?vue&type=script&lang=ts&"
export * from "./EmbeddedViewer.vue?vue&type=script&lang=ts&"
import style0 from "./EmbeddedViewer.vue?vue&type=style&index=0&id=3fa3558a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa3558a",
  null
  
)

export default component.exports